export type AvailablePageTemplates = {
  documentType: string;
};

export const PageTemplates: AvailablePageTemplates[] = [
  {
    documentType: 'pageHome',
  },
  {
    documentType: 'pageAboutUs',
  },
  {
    documentType: 'pageLegal',
  },
  {
    documentType: 'pageReviews',
  },
  {
    documentType: 'pageManifesto',
  },
  {
    documentType: 'pageSuccessStoriesSingle',
  },
  {
    documentType: 'pageRules',
  },
  {
    documentType: 'pageAffiliateOverview',
  },
  {
    documentType: 'pagePayout',
  },
  {
    documentType: 'pageAffiliate',
  },
  {
    documentType: 'pageSuccessStoriesOverview',
  },
  {
    documentType: 'pageFAQ',
  },
  {
    documentType: 'pageWhyPropTrading',
  },
  {
    documentType: 'pageHowItWorks',
  },
  {
    documentType: 'pagePricing',
  },
  {
    documentType: 'pageAssets',
  },
  {
    documentType: 'pageGeneralRules',
  },
  {
    documentType: 'pageGeneralRulesV2',
  },
  {
    documentType: 'pageFabioAffiliate',
  },
  {
    documentType: 'pagePatrickAffiliate',
  },
  {
    documentType: 'pageRizAffiliate',
  },
  {
    documentType: 'pageFuturesOldDesign',
  },
  {
    documentType: 'pageChallengeOldDesign',
  },
  {
    documentType: 'pageTextOnlyLPOldDesign',
  },
  {
    documentType: 'pageAnniversary',
  },
  {
    documentType: 'pageEcommerce',
  },
  {
    documentType: 'pageFuturesLP',
  },
  {
    documentType: 'pageThankYou',
  },
  {
    documentType: 'pageEvent',
  },
  {
    documentType: 'pageEventThankyou',
  },
  {
    documentType: 'pageReplay',
  },
  {
    documentType: 'pageCareerOverview',
  },
  {
    documentType: 'pageCareerDetail',
  },
  {
    documentType: 'pageElite',
  },
  {
    documentType: 'pageTradingCompetition',
  },
  {
    documentType: 'pageBlogOverview',
  },
  {
    documentType: 'pageBlogPost',
  },
  {
    documentType: 'pageCompetitor',
  },
];
